import React, {useContext} from 'react'
import MyContext from "../context/MyContext"

const LoadMore = () => {
    const context = useContext(MyContext)   
    const { page, setPage, result } = context

    return (
        <div className="load_more">
            {
                result < page * 12 ? ""
                : <button onClick={() => setPage(page+1)}>Load more</button>
            }
        </div>
    )
}

export default LoadMore
